import {
  ROUTE_TODAY,
  ROUTE_LIBRARY,
  ROUTE_CHAT_GENERAL
} from '../helpers/Paths'

// Icons
import { ReactComponent as IconToday } from '../../../assets/images/icons/icon-today.svg'
import { ReactComponent as IconChat } from '../../../assets/images/icons/icon-chat.svg'
import { ReactComponent as IconBook } from '../../../assets/images/icons/icon-book.svg'

/**
 * Navigates the app to a given path and tracks the event
 * @param {String} path The path to which to navigate the app
 * @param {Object} history The object to get the browser history
 */
const navigateTo = (path, history, data) => {
  // Disable Intercom
  // Attempt to reload the Intercom widget
  // try {
  //   window.Intercom('update')
  // } catch (e) {
  //   console.error(e)
  // }

  if (data) {
    return history.push({
      pathname: path,
      state: data
    })
  }

  return history.push(path)
}

/**
 * Returns the primary app menu
 */
const menu = () => [
  {
    route: ROUTE_TODAY,
    icon: <IconToday />,
    label: 'Today'
  },
  {
    route: ROUTE_LIBRARY,
    icon: <IconBook />,
    label: 'Library'
  },
  {
    route: ROUTE_CHAT_GENERAL,
    icon: <IconChat />,
    label: 'Chat'
  }
]

export { navigateTo, menu }
